import Tree from "./Tree";
import domready from "domready";
import debounce from "debounce";
import raf from "raf";

import config from "./config.js"

let canvas, ctx, tree, start, width, height, leaf;

import SimplexNoise from "./noise"
import { TAU } from "./math";

const noise = new SimplexNoise();

const LEAF_SIZE = 3;
const LEAF_SCALE = 0.5;

const leafs = new Float32Array(config.numLeafs * LEAF_SIZE);


function initLeafs()
{
    for (let i = 0; i < leafs.length; i+=LEAF_SIZE)
    {
        leafs[i] = Math.random() * width;
        leafs[i+1] = Math.random() * height;
        leafs[i+2] = Math.random();
    }
}

// noinspection ES6UnusedImports
import STYLE from "./style.css"

function render()
{

    const numTips = tree.tips.length;

    const { points, tips } = tree;

    const { leafWindFactor  } = config;


    const time = Date.now() - start;

    ctx.clearRect(0,0, width, height);

    ctx.fillStyle = "#90482a";
    ctx.beginPath();

    const windX = Math.cos(time * 0.0003) * 100;
    const windY = Math.cos(time * 0.0007) * 50;

    ctx.moveTo(points[0], points[1]);

    for (let i = 3; i < points.length; i+=3)
    {

        const x = points[i];
        const y = points[i + 1];
        const depth = points[i + 2];

        const factor = noise.noise2D(x  * 0.001 + time * 0.0005, y * 0.001) * ( depth * 0.05);

        ctx.lineTo( ( x + windX * factor) , ( y + windY * factor));
    }

    ctx.fill();
    ctx.fillStyle = "rgba(10,160,60,0.5)";

    for (let i = 0; i < tips.length; i++)
    {
        const tip = tips[i];

        ctx.beginPath();
        ctx.moveTo(tip.x, tip.y);

        const factor = noise.noise2D(tip.x  * 0.001 + time * 0.0005, tip.y * 0.001) * 0.4;

        ctx.arc( ( tip.x + windX * factor) , ( tip.y + windY * factor), 75, 0, TAU, false);
        ctx.fill();
    }

    for (let i = 0; i < leafs.length; i += LEAF_SIZE)
    {
        ctx.save();
        let x = leafs[i  ] + windX * leafWindFactor;
        let y = leafs[i+1] + windY * leafWindFactor;
        let z = leafs[i+2];


        const rnd0 = noise.noise2D( x * 0.0001, y * 0.001);
        const rnd1 = noise.noise2D( y * 0.0001, x * 0.001);

        // const dx = noise.noise2D( y, x);
        // const dy = noise.noise2D( x, y);
        //
        // x += dx;
        // y += dy;

        x += rnd1;
        y -= rnd1 - 1;

        const angle = rnd0 * TAU;


        if (x < -64)
        {
            x += width + 128;
        }
        if (y < -64)
        {
            y += height + 128;
        }

        if (x > width + 64)
        {
            x -= width + 128;
        }
        if (y > height + 64)
        {
            y -= height + 128;
        }

        leafs[i] = x;
        leafs[i+1] = y;

        ctx.translate(x + 32,y + 20);
        ctx.rotate(angle);
        ctx.scale(0.25 + 0.5 * z * LEAF_SCALE , 0.25 + 0.5 * z * LEAF_SCALE);

        ctx.drawImage(leaf,  0, 0);
        ctx.restore();

    }

    raf(render)
}

const resizeCanvasToScreen = debounce( () =>
{
    width = (window.innerWidth - 1)|0;
    height = (window.innerHeight - 1)|0;

    initLeafs();

    canvas.width = width;
    canvas.height = height;
}, 150, true);

domready(() => {

    canvas = document.getElementById("screen");
    leaf = document.getElementById("leaf");
    ctx = canvas.getContext("2d");

    resizeCanvasToScreen();

    config.start[0] = width/2;
    config.start[1] = height * 0.75;

    tree = new Tree(config);


    window.addEventListener("resize", resizeCanvasToScreen, true);

    start = Date.now();
    raf(render)
});

